export default {
	'delete-journal': 'Günlüğü sil',
	'view-the-associated-invoice': 'İlgili faturayı görüntüle',
	'there-are-no-details': 'Hiçbir ayrıntı yok',
	'new-journal': 'Yeni yevmiye defteri'
}